/**
 * "Render a view with no baked assets over the primary view's shell" — a per-device escape
 * hatch, OFF by default (AUD-3 IM-6 / F-48).
 *
 * With it off, a "front" view whose bake never synced to this device stops the run and names
 * itself. With it on, it composites over the BACK view's shell and mask: plausible-looking,
 * reported as a success, auto-saved to the customer's folder, and indistinguishable from a
 * real per-view bake except for one warn trace. That is a shipping-the-wrong-product default,
 * so it is now a choice the operator makes deliberately.
 *
 * Persisted to localStorage (like `renderBackend.ts`) so the choice survives reloads on this
 * device and never syncs to the cloud.
 */
const KEY = "genz.render.primaryViewFallback";
export const PRIMARY_VIEW_FALLBACK_KEY = KEY;

export function getPrimaryViewFallback(): boolean {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export function setPrimaryViewFallback(on: boolean): void {
  try {
    if (on) localStorage.setItem(KEY, "1");
    else localStorage.removeItem(KEY);
  } catch {
    /* private mode / no storage — the default (off) is the safe one */
  }
}
